module.exports = __webpack_public_path__ + "static/media/page-before-over.c0b67bc2.svg";